// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — foto.styled.classic.js, новая — foto.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './foto.styled.classic';
import * as cp from './foto.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const Buttons = isCp ? cp.Buttons : classic.Buttons;
export const Content = isCp ? cp.Content : classic.Content;
